import axios from 'axios';
import { getAuthHeader } from '../utils/auth';

const API_URL = process.env.REACT_APP_API_URL + 'stats';

export const getStats = async (startDate, endDate, courier, city) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (courier) params.append('courier', courier);
  if (city) params.append('city', city);
  
  const response = await axios.get(`${API_URL}?${params.toString()}`, { headers: getAuthHeader() });
  return response.data;
};

export const getProductsStats = async (courier, city) => {
  const params = new URLSearchParams();
  if (courier) params.append('courier', courier);
  if (city) params.append('city', city);
  
  const response = await axios.get(`${API_URL}/products-stats?${params.toString()}`, { headers: getAuthHeader() });
  return response.data.data;
};

export const getIssuedStats = async (startDate, endDate, courier, city) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (courier) params.append('courier', courier);
  if (city) params.append('city', city);
  
  const response = await axios.get(`${API_URL}/issued?${params.toString()}`, { headers: getAuthHeader() });
  return response.data;
};

export const getCryptoStats = async (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  const response = await axios.get(`${API_URL}/crypto?${params.toString()}`, { headers: getAuthHeader() });
  return response.data;
};
